
import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { OfferPropertyCompare } from '../../../containers/offers/OfferPropertyCompare'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'
import { Loading } from '../../../components/Loading'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { SignalRProvider } from 'BrokerTsLib/src/context/SignalRProvider'
import PropertyOffersProvider from '../../../context/PropertyOffersProvider'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import { useNavigate } from 'react-router-dom'
import { Box } from '@chakra-ui/react'

const baseUrl = process.env.PUBLIC_URL
const hubUrl = process.env.REACT_APP_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

const _Step3 = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/chaloupka/wizard/too-far', { replace: true })
  }

  return (
    <Section>
      <StepsContent step={3}>
        {isLoadingData && <Loading large={true} />}
        {(!paramsId || insuranceParams) && !isLoadingData &&
          <SignalRProvider url={url}>
            <PropertyOffersProvider>
              <Container>
                <Steps icon="house" />
              </Container>

              <InsuranceInfo />
              {/* pokud se nechá zde OfferPropertyCompare, tak je lišta v InsuranceInfo fixována k hornímu okraji, ale box s nabídkami není roztažený na celou šířku okna
                  <Box sx={{ px: 4 }}>
                    <OfferPropertyCompare />
                  </Box> */}

              <Box sx={{ px: 4 }}>
                <OfferPropertyCompare />
              </Box>


              <WizardForbiddenMessage />

            </PropertyOffersProvider>
          </SignalRProvider>
        }
      </StepsContent>
    </Section>

  )
}

export const Step3 = WithAuth(_Step3)